import React from 'react';
import Hero from './components/gallery/Hero';
import Main from './components/gallery/Main';

const Gallery = () => {
  return (
    <div>
      <Hero />
      <Main />
    </div>
  )
}

export default Gallery;